import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const StatBand = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${tokens.space.sm};
  margin-bottom: 1.25rem;

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`

export const FilterBar = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const StatusTabs = styled.div`
  margin-right: auto;
`

export const PersonCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
`

export const PersonAvatar = styled.div`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 100%;
  overflow: hidden;
  flex: none;
  background: ${tokens.surface.inset};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const PersonText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
`

export const PersonName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const PersonMeta = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const DateCell = styled.span`
  font-size: ${tokens.font.label};
  font-variant-numeric: tabular-nums;
  color: ${tokens.text.secondary};
`

export const DurationCell = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  justify-content: flex-end;
  white-space: nowrap;
`

export const QuickBtn = styled.button<{ $variant: 'approve' | 'reject' }>`
  width: 2rem;
  height: 2rem;
  display: grid;
  place-items: center;
  flex: none;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  color: ${(p) => (p.$variant === 'approve' ? tokens.status.success.fg : tokens.status.danger.fg)};
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${(p) => (p.$variant === 'approve' ? tokens.status.success.fg : tokens.status.danger.fg)};
    background: ${tokens.surface.glass};
  }

  svg {
    width: 1rem;
    height: 1rem;
  }
`

export const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
`
